export function hasDeletePermission(permissions: string[]) {
	return permissions.includes("DOCUMENT_DELETE");
}

export function hasStartProcessPermission(permissions: string[]) {
	return permissions.includes("START_PROCESS");
}

export function hasUpdateDocumentPermission(permissions: string[]) {
	return permissions.includes("DOCUMENT_UPDATE");
}
